import { render } from "./ImportErpStockPage.vue?vue&type=template&id=5d8e51fb"
import script from "./ImportErpStockPage.vue?vue&type=script&lang=js"
export * from "./ImportErpStockPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__